export const CONFIG_GRID_DEFAULT = {
	search: false,
	resizable: true,
	data: [],
	autoWidth: true,
	width: '100%',
	sort: false,
	style: {
		container: { border: 'none' },
		table: { border: 'none' },
		tr: { border: 'none' },
		th: { 'border-bottom': '1px solid #e9ecef', padding: '8px' },
		td: {
			'border-bottom': '1px solid #e9ecef',
			cursor: 'pointer',
			color: '#495057',
			'font-family': 'Roboto Flex',
			'font-size': '14px',
			'font-weight': 500,
			'line-height': '150%',
			'letter-spacing': '-0.28px',
			padding: '8px',
		},
		footer: { border: 'none' },
	},
	language: {
		search: {
			placeholder: 'Busque aqui...',
		},
		pagination: {
			previous: 'Anterior',
			next: 'Próximo',
			navigate: function (page, pages) {
				return `Página ${page} de ${pages}`
			},
			page: function (page) {
				return `Página ${page}`
			},
			showing: function (from, to, total) {
				return `Mostrando registros`
			},
			of: 'de',
			to: 'a',
			results: function () {
				return 'resultados'
			},
		},
		sort: {
			sortAsc: 'Classificar em ordem crescente',
			sortDesc: 'Classificar em ordem decrescente',
		},
		loading: 'Carregando...',
		noRecordsFound: 'Nenhum registro encontrado',
		error: 'Ocorreu um erro ao buscar os dados',
		empty: 'Nenhum dado disponível',
		columns: {
			select: 'Selecionar',
			actions: 'Ações',
		},
		buttons: {
			ok: 'OK',
			cancel: 'Cancelar',
			close: 'Fechar',
			save: 'Salvar',
			edit: 'Editar',
			delete: 'Excluir',
			view: 'Visualizar',
			export: 'Exportar',
			print: 'Imprimir',
		},
	},
}
